import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=f06eb4ee&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=f06eb4ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06eb4ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f06eb4ee')) {
      api.createRecord('f06eb4ee', component.options)
    } else {
      api.reload('f06eb4ee', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=f06eb4ee&scoped=true&", function () {
      api.rerender('f06eb4ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2pnM7nj6H7fu4/JS/comp/SearchFilterTokens.vue"
export default component.exports